import React from "react"
import ReactDOM from "react-dom"
import "./index.scss"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { QueryClient, QueryClientProvider } from "react-query"

const queryClient = new QueryClient()

import "@livingdesign/bogle/dist/Bogle.css"
import "@walmart-web/livingdesign-components/livingdesign-components.esm.css"
import "@walmart-web/livingdesign-icons/font/build/LivingDesign.min.css"
import { LivingDesignProvider } from "@walmart-web/livingdesign-components"
import TagManager from "react-gtm-module"
import config from "config/config"

TagManager.initialize({ gtmId: config.google_tag_manager_id })

ReactDOM.render(
	<React.StrictMode>
		<LivingDesignProvider>
			<QueryClientProvider client={queryClient}>
				<App />
			</QueryClientProvider>
		</LivingDesignProvider>
	</React.StrictMode>,
	document.getElementById("root")
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
